import Controller from '@ember/controller';

export default class PasswordResetController extends Controller {
  queryParams = ['reset_token'];

  get resetToken() {
    return this.reset_token;
  }
}
